import { Exception, ExceptionCode } from '@konv/exceptions';
import { SaiposOrderChoiceItem } from './SaiposOrderChoiceItem';

export class SaiposOrderItem {
	constructor({
		integration_code,
		desc_item,
		quantity,
		unit_price,
		notes,
		choice_items,
	}) {
		this.integration_code = integration_code;
		this.desc_item = desc_item;
		this.quantity = quantity;
		this.unit_price = unit_price;
		this.notes = notes;
		this.choice_items = choice_items;
	}

	static from(item) {
		const size = item.sizes[0];
		const sku = size.sku || item?.sku;
		const price = item.sizes[0].price;
		const quantity = item.quantity > 1 ? item.quantity : size.quantity;
		const observation = item.observation || '';

		if (!sku) {
			throw new Error(`O item ${item.name} está sem SKU`);
		}

		const childrenItens = SaiposOrderChoiceItem.from(item);

		const unitPrice = price;

		return new SaiposOrderItem({
			integration_code: sku,
			desc_item: item.name,
			quantity: quantity,
			unit_price: unitPrice,
			notes: observation,
			choice_items: childrenItens,
		});
	}
}
